import classNames from 'classnames';
import RewardsStoreCard from '../RewardsStoreCard';

import './RewardsStoreList.scss';

const RewardsStoreList = ({
  storesList = [],
  onClick,
  className,
  trackerProps = {},
}) => (
  <div className={classNames('RewardsStoreList', className)}>
    {storesList.map((store, index) => (
      <RewardsStoreCard
        key={`store-${store.id}`}
        index={index}
        store={store}
        onClick={onClick}
        trackerProps={trackerProps}
      />
    ))}
  </div>
);

export default RewardsStoreList;
